<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <h2 mat-dialog-title cdkDragHandle>{{ title }}</h2>

  <form [formGroup]="form" (ngSubmit)="save()" novalidate>
    <mat-dialog-content class="ftp-dialog-content">

      <div *ngIf="serverError" class="form-banner" role="alert">
        <mat-icon>error_outline</mat-icon>
        <span>{{ serverError }}</span>
      </div>

      <!-- ================= GENERAL ================= -->
      <section class="form-section">
        <h3 class="section-title">General</h3>
        <div class="section-grid">
          <mat-form-field appearance="outline" class="span-2">
            <mat-label>Name</mat-label>
            <input matInput formControlName="ftpName" [maxlength]="maxLength.ftpName"
                   placeholder="e.g. Partner SFTP drop" cdkFocusInitial />
            <mat-error>{{ errorFor('ftpName') }}</mat-error>
          </mat-form-field>

          <mat-slide-toggle formControlName="isActive" color="primary" class="active-toggle">
            {{ form.get('isActive')?.value ? 'Active' : 'Inactive' }}
          </mat-slide-toggle>
        </div>
      </section>

      <!-- ================= CONNECTION ================= -->
      <section class="form-section">
        <h3 class="section-title">Connection</h3>
        <!-- Server Type | Port | Connection Timeout on one row; Server Location full width below. -->
        <div class="connection-row">
          <mat-form-field appearance="outline">
            <mat-label>Server Type</mat-label>
            <mat-select formControlName="ftpServerType">
              <mat-option *ngFor="let type of ftpServerTypes" [value]="type">
                {{ FtpServerTypeUtil.toString(type) }}
              </mat-option>
            </mat-select>
            <mat-error>{{ errorFor('ftpServerType') }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Port</mat-label>
            <input matInput type="number" min="1" max="65535" step="1" formControlName="controlPort" />
            <mat-error>{{ errorFor('controlPort') }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline"
                          [matTooltip]="'Seconds allowed to connect when testing and using this service (' + timeoutLimits.min + '–' + timeoutLimits.max + ').'">
            <mat-label>Connection Timeout (s)</mat-label>
            <input matInput type="number" [min]="timeoutLimits.min" [max]="timeoutLimits.max" step="1" formControlName="connectionTimeout" />
            <mat-hint>{{ timeoutLimits.min }}–{{ timeoutLimits.max }}</mat-hint>
            <mat-error>{{ errorFor('connectionTimeout') }}</mat-error>
          </mat-form-field>
        </div>

        <div class="section-grid">
          <mat-form-field appearance="outline" class="span-2">
            <mat-label>Server Location</mat-label>
            <input matInput formControlName="ftpServerLocation" [maxlength]="maxLength.ftpServerLocation"
                   placeholder="ftp.example.com" autocomplete="off" />
            <mat-hint>Host name or IP address only — no ftp:// prefix or port.</mat-hint>
            <mat-error>{{ errorFor('ftpServerLocation') }}</mat-error>
          </mat-form-field>
        </div>
      </section>

      <!-- ================= AUTHENTICATION ================= -->
      <section class="form-section">
        <h3 class="section-title">Authentication</h3>
        <div class="section-grid">
          <mat-form-field appearance="outline">
            <mat-label>Username</mat-label>
            <input matInput formControlName="userName" [maxlength]="maxLength.userName" autocomplete="off" />
            <mat-error>{{ errorFor('userName') }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" [floatLabel]="isEdit ? 'always' : 'auto'">
            <mat-label>Password</mat-label>
            <input matInput formControlName="password" [maxlength]="maxLength.password"
                   [type]="showPassword ? 'text' : 'password'" autocomplete="new-password"
                   [placeholder]="isEdit ? '••••••••' : ''" />
            <button mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility()" [disabled]="revealingPassword"
                    [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
                    [matTooltip]="showPassword ? 'Hide password' : 'Show password'">
              <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-hint *ngIf="isEdit">The saved password is kept unless you enter a new one.</mat-hint>
            <mat-error>{{ errorFor('password') }}</mat-error>
          </mat-form-field>
        </div>
      </section>
    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions">
      <button mat-stroked-button type="button" (click)="testConnection()" [disabled]="saving || testing">
        <mat-icon>lan</mat-icon> Test Connection
      </button>
      <span class="spacer"></span>
      <button mat-stroked-button type="button" (click)="cancel()" [disabled]="saving">Cancel</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="saving || testing">
        <mat-spinner *ngIf="saving" diameter="18" class="button-spinner"></mat-spinner>
        {{ saving ? 'Saving…' : (isEdit ? 'Save Changes' : 'Add Service') }}
      </button>
    </mat-dialog-actions>
  </form>
</div>
